var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlorri({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 42,
    viewBox: "0 0 81 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#036BF5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 9C4.475 9 0 13.475 0 19s4.475 10 10 10 10-4.475 10-10S15.525 9 10 9zm0 15.138a5.07 5.07 0 0 1-5.083-5.083A5.07 5.07 0 0 1 10 13.972a5.07 5.07 0 0 1 5.083 5.083c.055 2.763-2.265 5.083-5.083 5.083zM39 9c-5.525 0-10 4.475-10 10s4.475 10 10 10 10-4.475 10-10S44.525 9 39 9zm0 15.138a5.07 5.07 0 0 1-5.083-5.083A5.07 5.07 0 0 1 39 13.972a5.07 5.07 0 0 1 5.083 5.083c0 2.763-2.265 5.083-5.083 5.083zM25.989 0H23.01C22.45 0 22 .434 22 .977v26.046c0 .543.45.977 1.011.977h2.978c.562 0 1.011-.434 1.011-.977V.977C26.944.434 26.494 0 25.989 0zM79.989 9H77.01C76.45 9 76 9.427 76 9.96v17.08c0 .533.45.96 1.011.96h2.978c.562 0 1.011-.427 1.011-.96V9.96c0-.533-.45-.96-1.011-.96zM60.985 9h-2.482c-4.006 0-7.22 2.944-7.503 6.637v11.4c0 .535.451.963 1.015.963h2.99c.564 0 1.016-.428 1.016-.963V16.118c0-1.338 1.128-2.355 2.482-2.355h2.482c.564 0 1.015-.428 1.015-.963V9.963C61.944 9.428 61.492 9 60.985 9zM72.985 9h-2.482c-4.006 0-7.22 2.944-7.503 6.637v11.4c0 .535.451.963 1.015.963h2.99c.564 0 1.016-.428 1.016-.963V16.118c0-1.338 1.128-2.355 2.482-2.355h2.482c.564 0 1.015-.428 1.015-.963V9.963C74 9.428 73.549 9 72.985 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.558 31.06l-3.37-1.965c-.442-.265-1.05.054-1.05.585v2.602c0 2.655-2.155 4.938-4.972 4.991-2.873.053-5.249-2.124-5.249-4.885V29.68c0-.531-.608-.85-1.05-.585L.497 31.06c-.276.16-.497.478-.497.797v.372c0 5.31 4.365 9.664 9.89 9.77 5.58.054 10.11-4.248 10.11-9.611v-.478c0-.372-.166-.69-.442-.85z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 4.5,
    r: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlorri);
export default __webpack_public_path__ + "static/media/glorri.029a34088bbca40ff32dcd6c04b2e2a2.svg";
export { ForwardRef as ReactComponent };